class CartNote extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleSubmit = this.handleSubmit.bind(this)

    this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)
  }

  handleSubmit () {
    window.BAO.Cart.updateNote(this.els.note.element.value)

    this.els.heading.elements.forEach((headingEl) => {
      headingEl.setAttribute(
        'aria-hidden',
        headingEl.dataset.state === 'added'
          ? this.els.note.element.value === ''
          : this.els.note.element.value !== '',
      )
    })
  }
}

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', CartNote)
}
